module.exports = __webpack_public_path__ + "img/stop.ec7d4ddc.svg";